// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';

const EndDivider = styled<any, Theme>('div')`
  margin-bottom: 2rem;
  & + .divider {
    margin-top: 0;
  }
`;

export default () => <EndDivider />;
